var _path, _path2, _path3, _path4, _path5, _path6, _rect, _path7, _path8, _circle, _rect2, _circle2, _circle3, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _line, _line2, _circle4, _circle5, _line3, _line4, _line5, _line6, _circle6, _circle7, _circle8, _path14, _path15, _path16, _path17, _path18, _path19, _circle9, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _circle0, _line7, _line8, _path28, _path29, _path30, _path31, _path32, _rect3, _line9, _line0, _line1, _rect4, _path33, _path34, _path35, _rect5, _rect6, _rect7, _rect8, _path36, _circle1, _circle10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaidsearchmanagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 291,
    height: 280,
    viewBox: "0 0 291 280",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 199.282V243.604H47.0804",
    stroke: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4546 237.788H6.81641L6.81641 201.205",
    stroke: "#F58120",
    strokeWidth: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M162.643 257.487L157.366 271.909L141.537 234.975L178.12 251.859L162.643 257.487ZM162.643 257.487L172.492 267.336",
    stroke: "#333333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M161.016 268.041L148.23 239.196L177.778 252.382L165.277 256.778L161.016 268.041Z",
    fill: "#F58120"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4922 148.795C35.658 149.029 42.2007 151.539 43.045 159.699M32.4922 141.76C38.2376 142.229 49.8691 146.473 50.4319 159.699M258.673 147.388L270.281 159.348V147.388H258.673Z",
    stroke: "#333333"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M243.387 90.9199H289.819V138.056",
    stroke: "#333333"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.9492,
    y: 101.805,
    width: 42.6181,
    height: 27.8442,
    rx: 0.5,
    stroke: "#1E334E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3248 128.771L34.2462 112.505L54.1675 128.771H14.3248Z",
    stroke: "#1E334E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9685 104.186L34.2558 117.016L18.5431 104.186L49.9685 104.186Z",
    fill: "white",
    stroke: "#1E334E",
    strokeWidth: 4
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34.2649,
    cy: 163.919,
    r: 5.62814,
    fill: "#F58120"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 239.465,
    y: 177.082,
    width: 46.8392,
    height: 46.8392,
    rx: 3.5,
    stroke: "#1E334E"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 128.87,
    cy: 244.473,
    r: 4.77638,
    stroke: "#333333"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 183.743,
    cy: 55.2277,
    r: 6.09046,
    stroke: "#1098F7",
    strokeWidth: 4
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M162.289 14.0699C162.289 19.898 157.564 24.6226 151.736 24.6226C145.908 24.6226 141.184 19.898 141.184 14.0699C141.184 8.24173 145.908 3.51709 151.736 3.51709C157.564 3.51709 162.289 8.24173 162.289 14.0699Z",
    fill: "#F58120"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M236.157 63.3154C236.157 69.532 231.117 74.5717 224.901 74.5717C218.684 74.5717 213.645 69.532 213.645 63.3154C213.645 57.0987 218.684 52.0591 224.901 52.0591C231.117 52.0591 236.157 57.0987 236.157 63.3154Z",
    fill: "#F58120"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M177.762 224.07C177.762 228.927 173.825 232.864 168.968 232.864C164.111 232.864 160.174 228.927 160.174 224.07C160.174 219.214 164.111 215.276 168.968 215.276C173.825 215.276 177.762 219.214 177.762 224.07Z",
    fill: "#F58120"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M225.6 271.206C225.6 276.063 221.662 280 216.806 280C211.949 280 208.012 276.063 208.012 271.206C208.012 266.349 211.949 262.412 216.806 262.412C221.662 262.412 225.6 266.349 225.6 271.206Z",
    fill: "#F58120"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8282 63.316C89.8282 69.1441 85.1036 73.8687 79.2754 73.8687C73.4473 73.8687 68.7227 69.1441 68.7227 63.316C68.7227 57.4878 73.4473 52.7632 79.2754 52.7632C85.1036 52.7632 89.8282 57.4878 89.8282 63.316Z",
    fill: "#F58120"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M123.595 31.6571C123.595 33.9884 121.705 35.8783 119.373 35.8783C117.042 35.8783 115.152 33.9884 115.152 31.6571C115.152 29.3259 117.042 27.436 119.373 27.436C121.705 27.436 123.595 29.3259 123.595 31.6571Z",
    fill: "#F58120"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M102.485 255.377C102.485 257.708 100.595 259.598 98.2641 259.598C95.9328 259.598 94.043 257.708 94.043 255.377C94.043 253.046 95.9328 251.156 98.2641 251.156C100.595 251.156 102.485 253.046 102.485 255.377Z",
    fill: "#528FF5"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 143.303,
    y1: 134.982,
    x2: 152.448,
    y2: 134.982,
    stroke: "#1098F7",
    strokeWidth: 3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 147.963,
    y1: 130.501,
    x2: 147.963,
    y2: 139.647,
    stroke: "#1098F7",
    strokeWidth: 3
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 164.746,
    cy: 223.367,
    r: 8.99749,
    stroke: "#333333",
    strokeDasharray: "5 5"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 126.758,
    cy: 226.181,
    r: 4.68342,
    stroke: "#1098F7",
    strokeWidth: 4,
    strokeDasharray: "4 4"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 203.09,
    y1: 219.609,
    x2: 230.527,
    y2: 219.609,
    stroke: "#1098F7",
    strokeWidth: 4
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 214.355,
    y1: 240.01,
    x2: 241.793,
    y2: 240.01,
    stroke: "#1098F7",
    strokeWidth: 4
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 214.355,
    y1: 226.644,
    x2: 257.27,
    y2: 226.644,
    stroke: "#1098F7",
    strokeWidth: 4
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 214.355,
    y1: 232.975,
    x2: 257.27,
    y2: 232.975,
    stroke: "#1098F7",
    strokeWidth: 4
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 75.394,
    cy: 62.9643,
    r: 12.5151,
    stroke: "#1E334E"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 147.857,
    cy: 13.0151,
    r: 12.5151,
    stroke: "#1E334E"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 220.32,
    cy: 62.9643,
    r: 12.5151,
    stroke: "#1E334E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M121.941 184H54C51.2386 184 49 186.239 49 189V191C49 193.761 51.2386 196 54 196H243C245.761 196 248 193.761 248 191V189C248 186.239 245.761 184 243 184H174.471C173.229 184 172.032 184.462 171.112 185.296L169.759 186.523C168.839 187.356 167.642 187.818 166.401 187.818H130.135C128.962 187.818 127.826 187.406 126.926 186.653L125.149 185.166C124.25 184.413 123.114 184 121.941 184Z",
    stroke: "#1E334E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M149.389 202.618L150.372 205.646L150.485 205.991H150.848H154.032L151.456 207.863L151.162 208.076L151.274 208.422L152.258 211.45L149.683 209.578L149.389 209.365L149.095 209.578L146.519 211.45L147.503 208.422L147.615 208.076L147.321 207.863L144.746 205.991H147.929H148.293L148.405 205.646L149.389 202.618Z",
    fill: "#F58120",
    stroke: "#F58120"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M133.842 201L135.301 205.491H140.024L136.203 208.267L137.662 212.759L133.842 209.983L130.021 212.759L131.481 208.267L127.66 205.491H132.382L133.842 201Z",
    fill: "#F58120"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M118.297 201L119.756 205.491H124.479L120.658 208.267L122.117 212.759L118.297 209.983L114.476 212.759L115.936 208.267L112.115 205.491H116.838L118.297 201Z",
    fill: "#F58120"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M104.047 201L105.506 205.491H110.229L106.408 208.267L107.867 212.759L104.047 209.983L100.226 212.759L101.686 208.267L97.865 205.491H102.588L104.047 201Z",
    fill: "#F58120"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5 201L89.9593 205.491H94.6819L90.8613 208.267L92.3206 212.759L88.5 209.983L84.6794 212.759L86.1387 208.267L82.3181 205.491H87.0407L88.5 201Z",
    fill: "#F58120"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.427,
    cy: 160.403,
    r: 5.12814,
    stroke: "#333333"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M51 104H18L34.5 117L51 104Z",
    fill: "#F58120",
    stroke: "#F58120",
    strokeWidth: 2
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M274.858 161.105V149.145H262.898L274.858 161.105Z",
    fill: "#F58120"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M246.717 96.3809L284.355 96.381L284.355 132.964",
    stroke: "#F58120",
    strokeWidth: 4
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1211 160.68V144.925C105.487 144.925 96.0852 156.57 108.272 159.652C118.022 162.118 122.665 167.872 123.593 170.955C109.317 163.077 94.6924 160.68 89.1211 160.68Z",
    fill: "#F58120"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.8926 186.488H51.8926V187.488V189.248H53.8926V188.488H127.381L131.657 193.093L131.954 193.412H132.39H172.491H172.951L173.25 193.063L177.172 188.488H251.34V189.248H253.34V187.488V186.488H252.34H176.712H176.252L175.952 186.837L172.031 191.412H132.826L128.55 186.807L128.253 186.488H127.817H52.8926Z",
    fill: "#F58120"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M284 219V185C271.667 185 266.381 196.553 262.152 204.476C258.77 210.814 250.641 216.799 247 219H284Z",
    fill: "#F58120"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3047 85.124H204.139C172.129 98.1391 107.405 89.6969 95.7972 109.044C86.5107 124.521 72.9328 130.032 67.3047 130.853V89.124C67.3047 86.9149 69.0955 85.124 71.3047 85.124Z",
    fill: "#F58120"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M147.857 123.115V25.3262",
    stroke: "#1E334E"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 147.857,
    cy: 134.725,
    r: 12.5151,
    stroke: "#333333"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 160.873,
    y1: 123.811,
    x2: 208.705,
    y2: 75.9789,
    stroke: "#333333",
    strokeWidth: 2,
    strokeMiterlimit: 11.4737,
    strokeLinecap: "square",
    strokeDasharray: "1 10"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 138.894,
    y1: 125.394,
    x2: 86.1377,
    y2: 72.6374,
    stroke: "#333333",
    strokeWidth: 2,
    strokeMiterlimit: 11.4737,
    strokeLinecap: "square",
    strokeDasharray: "1 10"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M121.395 133.92C106.886 141.467 92.8279 142.519 87.002 142.11V162.16C98.6353 161.282 112.452 166.625 121.473 171.244C124.281 172.682 127.806 170.7 127.806 167.546V137.589C127.806 134.402 124.223 132.449 121.395 133.92Z",
    stroke: "#1E334E"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M87 163V174C87 176.209 88.7909 178 91 178V178C93.2091 178 95 176.209 95 174V163.862",
    stroke: "#1E334E"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0051 142.111C83.509 141.538 74.7085 143.267 74.3469 152.203C74.1944 155.983 77.4572 162.436 87.0051 162.161",
    stroke: "#1E334E"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1619 153.106C77.4231 145.933 83.779 144.545 86.3039 145.005V161.099C79.4082 161.32 77.0518 156.14 77.1619 153.106Z",
    fill: "#F58120"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5 175C92.5 175.828 93.1716 176.5 94 176.5C94.8284 176.5 95.5 175.828 95.5 175L92.5 175ZM92.5 163L92.5 175L95.5 175L95.5 163L92.5 163Z",
    fill: "#F58120"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 65.7168,
    y: 82.5146,
    width: 164.327,
    height: 101.01,
    rx: 6.5,
    stroke: "#1E334E"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 58.8789,
    y1: 106.341,
    x2: 73.6528,
    y2: 106.341,
    stroke: "#1098F7",
    strokeWidth: 4
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    x1: 65.2168,
    y1: 115.486,
    x2: 79.9907,
    y2: 115.486,
    stroke: "#1098F7",
    strokeWidth: 4
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    x1: 58.8789,
    y1: 124.632,
    x2: 73.6528,
    y2: 124.632,
    stroke: "#1098F7",
    strokeWidth: 4
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 203.59,
    y: 101.805,
    width: 76.387,
    height: 46.1357,
    fill: "#ECEFF3",
    stroke: "#333333"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M207 145H250C237.944 136.538 231.632 144.022 219.458 135.769C209.812 129.231 211.421 114.231 207 105V145Z",
    fill: "#F58120"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M239.037 121.94L244.117 124.873L239.037 127.806L239.037 121.94Z",
    stroke: "#333333",
    strokeWidth: 4
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M249.52 126.985L238.439 133.382L238.439 120.588L249.52 126.985Z",
    fill: "#F58120"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 12.2383,
    y: 190.449,
    width: 63.0201,
    height: 41.9146,
    rx: 5.5,
    fill: "white",
    stroke: "#333333"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 15.9434,
    y: 194.875,
    width: 55.5779,
    height: 33.0653,
    rx: 5,
    fill: "#F58120"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 15.9434,
    y: 202.613,
    width: 55.5779,
    height: 7.7387,
    fill: "#FFEBDA"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 56.0566,
    y: 216.683,
    width: 11.2563,
    height: 7.7387,
    rx: 2,
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M280.801 190.154C281.077 190.133 281.317 190.339 281.338 190.614C281.36 190.889 281.154 191.13 280.878 191.151L280.801 190.154ZM276.267 191.004L275.808 190.806L275.928 190.529L276.229 190.506L276.267 191.004ZM255.865 205.074L255.814 205.572L255.427 205.532L255.37 205.148L255.865 205.074ZM254.458 195.577L253.963 195.65L253.882 195.099L254.438 195.077L254.458 195.577ZM271.215 208.902L271.688 208.74L271.215 208.902ZM280.878 191.151L276.305 191.503L276.229 190.506L280.801 190.154L280.878 191.151ZM276.726 191.202L270.043 206.68L269.125 206.283L275.808 190.806L276.726 191.202ZM269.533 206.979L255.814 205.572L255.916 204.577L269.635 205.984L269.533 206.979ZM255.37 205.148L253.963 195.65L254.953 195.504L256.36 205.001L255.37 205.148ZM254.438 195.077L272.378 194.374L272.417 195.373L254.478 196.077L254.438 195.077ZM254.458 210.554H269.484V211.554H254.458V210.554ZM270.742 209.064C270.414 208.105 269.937 207.277 269.326 206.91L269.841 206.053C270.771 206.611 271.344 207.736 271.688 208.74L270.742 209.064ZM269.484 210.554C270.413 210.554 270.987 209.779 270.742 209.064L271.688 208.74C272.21 210.263 270.922 211.554 269.484 211.554V210.554Z",
    fill: "#1E334E"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    transform: "matrix(-1 0 0 1 257.62 215.98)",
    stroke: "white",
    strokeWidth: 2.62814
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    transform: "matrix(-1 0 0 1 268.868 215.98)",
    stroke: "white",
    strokeWidth: 2.62814
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaidsearchmanagement);
export default __webpack_public_path__ + "static/media/paidsearchmanagement.31d7f13ec81a3416c34b3a481ff64aa5.svg";
export { ForwardRef as ReactComponent };